import React, { useState } from "react";
import { useSimplicityImage } from "cms/images/hooks/use-simplicity-image";
import { SlideshowImageSettingsDialog } from "cms/components/components/hero-slideshow/edit/image/image-settings-dialog";
import { ImageSelectorDisplay } from "cms/components/components/hero-slideshow/edit/image/image-selector-display";
import { ImageSelectorButton } from "cms/components/components/hero-slideshow/edit/image/image-selector-button";
import { Logger } from "cms/utils/log/logger";

const SlideshowImageEditor = (props) => {

    const {
        image,
        setImage,
        settings,
        setSettings,
        onChangeImageData,
        onRemoveImage,
    } = props;

    const { prepareImageData, isValidImage } = useSimplicityImage();

    const url = image?.url;

    const [visible, setVisible] = useState(false);

    const onChangeImageWithSettings = async (image, settings) => {
        if (!image) {
            Logger.debug("remove image in onChangeImage");
        } else if (isValidImage(image)) {
            const image_data = await prepareImageData(image, settings);
            onChangeImageData(image_data);
        } else {
            Logger.error("Image supplied in onChangeImage was not a valid image.");
        }
    };

    return (
        <>
            <div className='component-editor-image-container'>
                {url &&
                    <ImageSelectorDisplay
                        image={image}
                        setOpen={setVisible}
                    />
                }

                {!url &&
                    <ImageSelectorButton
                        setOpen={setVisible}
                    />
                }
            </div>

            <SlideshowImageSettingsDialog
                visible={visible}
                setVisible={setVisible}
                image={image}
                settings={settings}
                onChangeImageWithSettings={onChangeImageWithSettings}
                onRemoveImage={onRemoveImage}
                setImage={setImage}
                setSettings={setSettings}
            />
        </>
    );
};

export { SlideshowImageEditor }; 